import { CartItemModel, CartItemModifierGroupModel } from "../models";

export const areModifiersEqual = (
  modifiersA: CartItemModifierGroupModel[],
  modifiersB: CartItemModifierGroupModel[]
): boolean => {
  if (modifiersA.length !== modifiersB.length) return false;
  return modifiersA.every((group, i) =>
    group.g_id === modifiersB[i].g_id &&
    group.modifiers.length === modifiersB[i].modifiers.length &&
    group.modifiers.every((mod, idx) => mod.m_id === modifiersB[i].modifiers[idx].m_id)
  );
};

// export const areModifiersEqual = (modifiersA: CartItemModifierGroupModel[], modifiersB: CartItemModifierGroupModel[]): boolean => {
//   if (modifiersA.length !== modifiersB.length) return false;
//   for (let i = 0; i < modifiersA.length; i++) {
//       if (modifiersA[i].g_id !== modifiersB[i].g_id ||
//           modifiersA[i].modifiers.length !== modifiersB[i].modifiers.length ||
//           !modifiersA[i].modifiers.every((mod, index) => mod.m_id === modifiersB[i].modifiers[index].m_id)) {
//           return false;
//       }
//   }
//   return true;
// }

export const cartActions = {
  increaseQuantity(cart: CartItemModel[], value: number | string) {
    return cart.map((item, index) => {
      const match = typeof value === "number" ? index === value : item.product_id === value;
      return match ? { ...item, product_qty: item.product_qty + 1 } : item;
    });
  },

  decreaseQuantity(cart: CartItemModel[], value: number | string) {
    return cart.reduce((acc, item, index) => {
      const match = typeof value === "number" ? index === value : item.product_id === value;

      if (match) {
        if (item.product_qty === 1) return acc; // remove item completely
        return [...acc, { ...item, product_qty: item.product_qty - 1 }];
      }

      return [...acc, item];
    }, [] as CartItemModel[]);
  }
};